import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["autoDismiss"];
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _dec, _class2, _descriptor15;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { observable, computed, action } from 'mobx';
import isString from 'lodash/isString';
import { extractMessageFromError } from '../utils/errorUtil';

// ID used for React key.
var _idCounter = 1;
var DEFAULT_DISMISS_TIME = 3000;
export var FlashMessageTypes = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error',
  WARN: 'warn'
};

/**
 * A single flash message with a fluent API.
 */
var FlashMessage = (_class = /*#__PURE__*/_createClass(
/**
 * Constructor sets the initial stuff.
 * If autoDismiss is set, the message with dismiss after
 * the specified amount of milliseconds.
 *
 * @param {object} opts
 * Will be set on the instance.
 */
function FlashMessage(opts) {
  _classCallCheck(this, FlashMessage);
  _initializerDefineProperty(this, "message", _descriptor, this);
  _initializerDefineProperty(this, "isShowing", _descriptor2, this);
  _initializerDefineProperty(this, "inProgress", _descriptor3, this);
  _initializerDefineProperty(this, "type", _descriptor4, this);
  /**
   * Shows the message again (if it was dismissed before).
   */
  _initializerDefineProperty(this, "show", _descriptor5, this);
  /**
   * Dismisses the message.
   */
  _initializerDefineProperty(this, "dismiss", _descriptor6, this);
  /**
   * Clears the dismiss timeout.
   *
   * @return {FlashMessage}
   * The instance.
   */
  _initializerDefineProperty(this, "clearDismissTimer", _descriptor7, this);
  /**
   * Sets up the message to auto dismiss.
   *
   * @param  {Number} ms
   * How long till it is dismissed?
   *
   * @return {FlashMessage}
   * The instance.
   */
  _initializerDefineProperty(this, "autoDismiss", _descriptor8, this);
  /**
   * Sets the given opts directly on the instance.
   *
   * @param {object} opts
   * Options to set.
   *
   * @return {FlashMessage}
   * The instance.
   */
  _initializerDefineProperty(this, "set", _descriptor9, this);
  /**
   * Marks this message as being an in-progress type.
   *
   * @param  {string} message
   * Optional message to set.
   *
   * @return {FlashMessage}
   * This instance.
   */
  _initializerDefineProperty(this, "progress", _descriptor10, this);
  /**
   * Marks the message as done (sets inProgress to false).
   * Basically like `set`, but with an automatic inProgress = false.
   *
   * @param  {object}   opts
   * Additional things to set.
   *
   * @return {FlashMessage}
   * The instance.
   */
  _initializerDefineProperty(this, "done", _descriptor11, this);
  /**
   * Marks the message as failed (sets inProgress to false).
   * Basically like `set`, but with an automatic inProgress = false.
   *
   * @param  {object}   opts
   * Additional things to set.
   *
   * @return {FlashMessage}
   * The instance.
   */
  _initializerDefineProperty(this, "failed", _descriptor12, this);
  /**
   * Marks the message as failed (sets inProgress = false and type to warn)
   *
   * @param  {object}   opts
   * Additional things to set.
   *
   * @return {FlashMessage}
   * The instance.
   */
  _initializerDefineProperty(this, "warn", _descriptor13, this);
  /**
   * Makes the message show the error.
   * Returns the error for easier throwing.
   *
   * @param {Error}
   * The error to extract a message from, and subsequently return.
   */
  _initializerDefineProperty(this, "forError", _descriptor14, this);
  opts = _objectSpread(_objectSpread({}, isString(opts) ? {
    message: opts
  } : opts), {}, {
    id: (_idCounter++).toString()
  });
  var _opts = opts,
    autoDismiss = _opts.autoDismiss,
    other = _objectWithoutProperties(_opts, _excluded);
  this.set(other);
  if (autoDismiss && !opts.inProgress) {
    this.autoDismiss(autoDismiss);
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "message", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isShowing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "inProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "type", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return FlashMessageTypes.DEFAULT;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "show", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this = this;
    return function () {
      _this.isShowing = true;
      return _this;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dismiss", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function () {
      _this2.isShowing = false;
      return _this2;
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "clearDismissTimer", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function () {
      clearTimeout(_this3._timeout);
      return _this3;
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "autoDismiss", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function () {
      var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DISMISS_TIME;
      _this4.clearDismissTimer();
      _this4._timeout = setTimeout(function () {
        _this4.dismiss();
      }, ms);
      return _this4;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "set", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (opts) {
      Object.assign(_this5, opts);
      return _this5;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "progress", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (message) {
      _this6.set({
        inProgress: true,
        message: message || _this6.message
      });
      return _this6;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "done", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function (opts) {
      // If passed just the message, make it an options object.
      if (typeof opts === 'string') {
        opts = {
          message: opts
        };
      }
      _this7.set(_objectSpread(_objectSpread({}, opts), {}, {
        inProgress: false,
        type: FlashMessageTypes.SUCCESS
      }));
      return _this7;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "failed", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function (opts) {
      // If passed just the message, make it an options object.
      if (typeof opts === 'string') {
        opts = {
          message: opts
        };
      }
      _this8.set(_objectSpread(_objectSpread({}, opts), {}, {
        inProgress: false,
        type: FlashMessageTypes.ERROR
      }));
      return _this8;
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "warn", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function (opts) {
      // If passed just the message, make it an options object.
      if (typeof opts === 'string') {
        opts = {
          message: opts
        };
      }
      _this9.set(_objectSpread(_objectSpread({}, opts), {}, {
        inProgress: false,
        type: FlashMessageTypes.WARN
      }));
      return _this9;
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "forError", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function (error) {
      _this10.failed(extractMessageFromError(error));
      return error;
    };
  }
}), _class);
/**
 * The Flash Message store.
 */
var FlashMessageStore = (_dec = action.bound, _class2 = /*#__PURE__*/function () {
  function FlashMessageStore() {
    _classCallCheck(this, FlashMessageStore);
    _initializerDefineProperty(this, "flashes", _descriptor15, this);
  }
  return _createClass(FlashMessageStore, [{
    key: "showingFlashes",
    get:
    /**
     * Computes the flashes to show.
     */
    function get() {
      return this.flashes.filter(function (x) {
        return x.isShowing;
      }).reverse();
    }

    /**
     * Creates and adds a new flash message.
     */
  }, {
    key: "create",
    value: function create(opts) {
      if (opts.id) {
        var flash = this.flashes.find(function (x) {
          return x.id === opts.id;
        });
        flash === null || flash === void 0 ? void 0 : flash.dismiss();
      }
      var message = new FlashMessage(opts);
      this.flashes.push(message);
      return message;
    }

    /**
     * Clears the flashes.
     */
  }, {
    key: "clear",
    value: function clear() {
      this.flashes.replace([]);
      return this;
    }

    /**
     * Shows a flash message for an error.
     * Returns the error so it can be thrown easily.
     *
     * @param {*} error
     */
  }, {
    key: "showForError",
    value: function showForError(error) {
      this.create({
        type: FlashMessageTypes.ERROR,
        message: extractMessageFromError(error)
      }).autoDismiss();
      return error;
    }
  }]);
}(), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "flashes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "showingFlashes", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showingFlashes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "create", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "create"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clear", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "clear"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showForError", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "showForError"), _class2.prototype), _class2);
export { FlashMessageStore as default };
//# sourceMappingURL=FlashMessageStore.js.map
